import { isNullItem } from "./isNullItem.js";
export function isDisabledItem(item) {
  return (!isNullItem(item) && item.disabled) ?? false;
}